import { FOCUS_BUCKETS, type FocusBucket } from "@ceo-cmd/shared";

export function isFocusBucket(value: string): value is FocusBucket {
  return (FOCUS_BUCKETS as readonly string[]).includes(value);
}
